import { AsyncPipe, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { I18nModule } from '@spartacus/core';
import { FacetComponent, KeyboardFocusModule } from '@spartacus/storefront';

import { FADE_IN_CONTENT_BY_HEIGHT_OPACITY } from '@app/core/constants/animations.constant';

@Component({
    selector: 'dp-facet',
    templateUrl: './facet.component.html',
    styleUrls: ['./facet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, SlicePipe, RouterLink, KeyboardFocusModule, I18nModule, MatIcon],
    animations: [FADE_IN_CONTENT_BY_HEIGHT_OPACITY]
})
export class DpFacetComponent extends FacetComponent {
  state = {
    opened: false
  };
  visibleValues = false;

  readonly route = inject(ActivatedRoute).snapshot.url;

  @HostBinding('class.opened')
  get opened(): boolean {
    return this.state.opened;
  }

  toggle($event: UIEvent): void {
    this.state.opened = !this.state.opened;

    $event.stopPropagation();
  }

  getExpandButtonVisibility(totalFacets: number | undefined, topVisible = 0): boolean {
    return topVisible < Number(totalFacets);
  }

  toggleExpandFacetValuesView(): void {
    if (!this.visibleValues) {
      this.facetService.increaseVisibleValues(this.facet);
      this.toggleVisibleValues();
    } else {
      this.facetService.decreaseVisibleValues(this.facet);
      this.toggleVisibleValues();
    }
  }

  private toggleVisibleValues(): void {
    this.visibleValues = !this.visibleValues;
  }
}
